import React from "react";
import { ABOUT } from "../lib/siteData";
import { useReveal } from "../lib/useReveal";

export default function About() {
  const [ref, visible] = useReveal();

  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28">
      <div ref={ref} className={`container-prose reveal ${visible ? "in" : ""}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <p className="overline">01 — About</p>
            <h2 className="h2-display mt-4 text-4xl sm:text-5xl text-ink">
              A practitioner. <br />
              <span className="italic text-forest">A scholar.</span>
            </h2>
          </div>

          <div className="lg:col-span-8">
            <p className="body-prose text-xl sm:text-2xl text-ink leading-snug font-light" style={{ fontFamily: '"Cormorant Garamond", serif' }}>
              {ABOUT.intro}
            </p>
            <div className="mt-8 space-y-5 body-prose text-base sm:text-lg text-ink/80 max-w-2xl">
              {ABOUT.body.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-3">
              {ABOUT.highlights.map((h, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 py-2 border-b border-ink-10"
                  data-testid={`about-highlight-${i}`}
                >
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-forest shrink-0" />
                  <span className="text-sm sm:text-[15px] body-prose text-ink/80">
                    {h}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
